import React from 'react';
import { TypographySettings } from '../../../types';

interface TextLinkProps {
	text: TypographySettings;
	/** Admin preview: the link does not navigate. */
	isPreview?: boolean;
}

/**
 * A text's words, as a link when the text has its own link.
 *
 * @param props Text settings.
 */
const TextLink: React.FC< TextLinkProps > = ( { text, isPreview } ) => {
	if ( ! text.link ) {
		return <>{ text.text }</>;
	}
	const newTab = !! text.openInNewTab;
	return (
		<a
			className="sb-text-link"
			href={ text.link }
			target={ newTab ? '_blank' : undefined }
			rel={ newTab ? 'noopener noreferrer' : undefined }
			onClick={ ( event ) => {
				if ( isPreview ) {
					event.preventDefault();
				}
			} }
		>
			{ text.text }
		</a>
	);
};

export default TextLink;
